import { useEffect } from 'react';
import Select from 'react-select';
import { Form } from 'react-simple-form-control';
import enderecoService from '../../services/EnderecoService';
import solicitacaoService from '../../services/SolicitacaoService';

const DadosBasicos = ({ form, onChangeForm, setLoading }) => {
    useEffect(() => {
        load();
    }, []);

    async function load() {
        setLoading(true);
        let _form = { ...form };

        const listEstado = await enderecoService.getUFs();

        _form.listEstado.value = listEstado;
        onChangeForm(_form);
        setLoading(false);
    }

    async function _handleEstadoChange(event) {
        setLoading(true);
        let _form = { ...form };

        const value = event.value;
        const cidades = await enderecoService.getCidades(value);
        _form.estadopolo.value = value;
        _form.listCidade.value = cidades;

        onChangeForm(_form);
        setLoading(false);
    }

    async function _handleCidadeChange(event) {
        setLoading(true);
        let _form = { ...form };

        const obj = {
            estado: form.estadopolo.value,
            cidade: event.label
        };

        const polos = await solicitacaoService.getPolos(obj);

        _form.listPolo.value = polos;
        _form.cidadepolo.value = event.value;

        onChangeForm(_form);
        setLoading(false);
    }

    async function _handlePoloChange(event) {
        setLoading(true);
        let _form = { ...form };

        _form.idpolo.value = event.value;
        _form.polo.value = event.label;

        onChangeForm(_form);
        setLoading(false);
    }

    async function handleInputChange(e) {
        const { name, value, type, checked } = e.target;
        let _form = { ...form };
        _form[name].value = type === "checkbox" ? checked : value;
        onChangeForm(_form);
    }

    return (
        <div className="card-body">
            <ul className="uninterconvenioempresas uninter-passo-interno">
                <li>
                    <div className="col-xs-12 col-sm-12 col-md-10 col-lg-9 uninter-campos">
                        <label>Consultor de Negócios/Gestor</label>
                        <input type="text" id="gestor" name="gestor" title="Favor informar o gestor/consultor que fez a divulgação do convênio. *Este campo é opcional"
                            value={form.gestor.value} onChange={handleInputChange} />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 uninter-campos">
                        <label htmlFor="ddlEstado">Estado (polo)</label>
                        <Select
                            onChange={_handleEstadoChange}
                            isLoading={form.listEstado.value.length > 0 ? false : true}
                            options={form.listEstado.value.map((o, i) => {
                                return { id: i, value: o.id, label: o.name };
                            })}
                            placeholder="SELECIONE"
                            id={"estadopolo"}
                            name={"estadopolo"}
                            defaultValue={{ label: "SELECIONE", value: 0 }}
                            value={
                                form.estadopolo.value !== null
                                    ? form.listEstado.value.find(e => e.id === form.estadopolo.value) && {
                                        label: form.listEstado.value.find(e => e.id === form.estadopolo.value)?.name,
                                        value: form.estadopolo.value
                                    }
                                    : { label: "SELECIONE", value: 0 }
                            }
                        />
                        <span className="error" id="estadoError"></span>
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 uninter-campos">
                        <label htmlFor="ddlCidade">Cidade (polo)</label>
                        <Select
                            onChange={_handleCidadeChange}
                            isLoading={form.listCidade.value.length > 0 ? false : true}
                            options={form.listCidade.value.map((o, i) => {
                                return { id: i, value: o.id, label: o.name };
                            })}
                            placeholder="SELECIONE"
                            id={"cidadepolo"}
                            name={"cidadepolo"}
                            defaultValue={{ label: "SELECIONE", value: 0 }}
                            value={
                                form.cidadepolo.value !== null
                                    ? form.listCidade.value.find(e => e.id === form.cidadepolo.value) && {
                                        label: form.listCidade.value.find(e => e.id === form.cidadepolo.value)?.name,
                                        value: form.cidadepolo.value
                                    }
                                    : { label: "SELECIONE", value: 0 }
                            }
                        />
                        <span className="error" id="cidadepoloError"></span>
                    </div>
                    {
                        form.listPolo &&
                        <div className="col-xs-12 col-sm-12 col-md-10 col-lg-8 uninter-campos">
                            <label htmlFor="ddlPolo">Polo</label>
                            <Select
                                onChange={_handlePoloChange}
                                isLoading={form.listPolo.value.length > 0 ? false : true}
                                options={form.listPolo.value.map((o, i) => {
                                    return { id: i, value: o.id, label: o.nome };
                                })}
                                placeholder="SELECIONE"
                                id={"polo"}
                                name={"polo"}
                                defaultValue={{ label: "SELECIONE", value: 0 }}
                                value={
                                    form.idpolo.value !== 0
                                        ? form.listPolo.value.find(e => e.id === form.idpolo.value) && {
                                            label: form.listPolo.value.find(e => e.id === form.idpolo.value)?.nome,
                                            value: form.idpolo.value
                                        }
                                        : { label: "SELECIONE", value: 0 }
                                }
                            />
                            <span className="error" id="poloError"></span>
                        </div>
                    }
                </li>
            </ul>
            <span className="error" id="dadosBasicosError"></span>
        </div>
    );
}

export default DadosBasicos;